import script from "./SearchBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchBtn.vue?vue&type=script&lang=ts&setup=true"

import "./SearchBtn.vue?vue&type=style&index=0&id=3950d4ff&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3950d4ff"]])

export default __exports__